<div *ngIf="bookingSearchService.isSavedSearchesVisible && bookingSearchService.savedSearchForm">
  <div *ngFor="let search of bookingSearchService.savedSearchList; let i = index" class="saved-searches-container">
    <span>
      {{search.name | titlecase}} ({{search.createdBy!.name}})
    </span>
    <p-button *ngIf="search.createdBy!.name == userService.userName" icon="pi pi-times"
      (onClick)="deleteSavedSearchById(search.id!)" class="saved-search-second-col"></p-button>
    <p-button icon="pi pi-arrow-circle-right" (onClick)="bookingSearchService.loadSavedSearchById(search.id!)"
      pTooltip="Go !" class="saved-search-third-col"></p-button>
    <p-button *ngIf="!search.isFavorite" icon="pi pi-star" pTooltip="Add to favorite"
      (onClick)="addToFavorite(search)" class="saved-search-fourth-col"></p-button>
    <p-button *ngIf="search.isFavorite" icon="pi pi-star-fill" pTooltip="Undo favorite"
      (onClick)="bookingSearchService.deleteFavoriteSearch(search)" class="saved-search-fourth-col"></p-button>
    <div *ngIf="bookingSearchService.savedSearchEditForms[i]"
      [formGroup]="bookingSearchService.savedSearchEditForms[i]!">
      name
      <input formControlName="name">
      <div formArrayName="rules">
        <div *ngFor="let rule of bookingSearchService.getRulesFormArray(i); let j = index">
          <div [formGroupName]="j">
            {{rule.value.id}}
            {{rule.value.action.name}}
            {{rule.value.column.label}}
            {{rule.value.operator.label}}
            value
            <input *ngIf="rule.value.column.searchDataType.name != 'date'" formControlName="value">
          </div>
        </div>
      </div>
      <p-button label="Save"></p-button>
    </div>
  </div>
  <div [formGroup]="bookingSearchService.savedSearchForm" class="search-create-box">
    <span>
      Name
    </span>
    <input pInputText formControlName="name">
    <div>
      <span>
        Make public
      </span>
      <p-checkbox [binary]="true" formControlName="isPublic"></p-checkbox>
    </div>
    <p-button label="Save current search" (onClick)="postCurrentSearchRules()"></p-button>
  </div>
</div>